module.exports = __webpack_public_path__ + "img/gfpt.fa63f562.png";